import styles from "@/pages/targetConfig/achievementDate/index.module.less";
import React from "react";

const config = {
  rowSelection: false,
  cacheDisabled: false,
  columns: [
    {
      title: "年",
      dataIndex: "year",
    },
    {
      title: "月",
      dataIndex: "month",
    },
    {
      title: "军种",
      dataIndex: "channelTypeName",
    },
    {
      title: "战略目标（万）",
      dataIndex: "performanceObjectivesAmount",
    },
    {
      title: "理想目标（万）",
      dataIndex: "pkTargetAmount",
    },
    {
      title: "操作",
      render: "actionTool",
      "fixed": "right"
    }
  ],
  search: [
    {
      name: "channelTypeId",
      label: "军种",
      itemType: "select",
      data: "armed",
      key: "id",
      labelKey: "typeName",
    },
    {
      name: "year",
      label: "年",
      itemType: "date",
      picker: "year"
    },
    {
      name: "month",
      label: "月",
      itemType: "date",
      format: 'M',
      picker: "month",
      panelRender: (panelNode) => <div className={styles.monthPickerBox}>{panelNode}</div>
    },
  ],
  footer: [
    {
      label: "新增",
      type: "primary",
      events: [
        "onClick:onAdd"
      ]
    },
  ]
}

export default config;